
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import indexedObject from './indexed-object.js';
import requireObjectCoercible$1 from './require-object-coercible.js';

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible = requireObjectCoercible$1;

var toIndexedObject = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

export { toIndexedObject as default };
//# sourceMappingURL=to-indexed-object.js.map
